<div
  *ngIf="isLoading"
  class="spinner-container">
  <mat-spinner
    [diameter]="100"
    mode="indeterminate"
  ></mat-spinner>
</div>